import env from '../env';
var isProd = env.isProduct || env.isPpe;
export default {
  beta: 'h5.51ping.com',
  product: 'h5.dianping.com'
};

// 深圳工行福利app登录跳转地址
export var passportUrl = isProd ? 'https://passport.maoyan.com' : 'https://passport.test.maoyan.com';